import { Link } from "react-router-dom";

export function Logo({ className = "", dark = false }) {
  return (
    <Link to="/" data-testid="logo-home-link" className={`group inline-flex flex-col leading-none ${className}`}>
      <span
        className={`font-serif text-2xl font-bold tracking-[0.22em] ${dark ? "text-white" : "text-brand-charcoal"}`}
      >
        REVERENCE
      </span>
      <span className="overline mt-1 text-[0.6rem] tracking-[0.4em] text-brand-red">
        CAR DETAILING
      </span>
    </Link>
  );
}
